import myHealth from '@web/containers/MyHealth/localization'
import _ from 'lodash'
const localization = {
  en: {
    vaccine: 'VACCINE',
    datesOnFile: 'DATE RECEIVED'
  },
  es: {
    vaccine: 'VACUNA',
    datesOnFile: 'FECHA EN QUE SE RECIBIÓ'
  },
  keyMapping: {
    vaccine: 'UFD_Print_Vaccine_Label',
    datesOnFile: 'UFD_Date_Received_Text'
  }
}

export default _.merge(myHealth, localization)
